export const ADID_COUNT = "ADID_COUNT"
export const USER_PREFERENCES = "USER_PREFERENCES"
export const CONTENT_ANALYTICS = "CONTENT_ANALYTICS"
export const WEBSITE_COUNT = "WEBSITE_COUNT"
export const VISIT_ANALYTICS = "VISIT_ANALYTICS"
export const ENGAGEMENT_BY_WEBSITE = "ENGAGEMENT_BY_WEBSITE"
export const ENGAGEMENT_PEAK_TIME = "ENGAGEMENT_PEAK_TIME"
export const ALL_WEBSITES = "ALL_WEBSITES"
export const EXPORT_DATA = "EXPORT_DATA"


export const END_URL = {
    ADID_COUNT : '/adid-mapping/count',
    USER_PREFERENCES : '/profile-management/interests/analytical',
    CONTENT_ANALYTICS : '/content-analytics/website-insights',
    WEBSITE_COUNT : '/content-analytics/website-count',
    VISIT_ANALYTICS : '/content-analytics/visit-analytics',
    ENGAGEMENT_BY_WEBSITE : '/content-analytics/engagement-by-website',
    ENGAGEMENT_PEAK_TIME : '/content-analytics/engagement-peak-time',
    ALL_WEBSITES : '/content-analytics/websites',
    EXPORT_CSV : '/content-analytics/website-insights/export',
    EXPORT_DATA : '/analytics/export',
}

export const TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
}

export const VALIDATION = {
    SYSTEM_ERROR: "System Error"
}

export const COLUMNS = [
    { name: 'website', title: 'Website' },
    { name: 'trendingCategories', title: 'Trending Categories' },
    { name: 'avgTimeOnPage', title: 'Avg. Time on Page(s)' },
    { name: 'avgUserSessions', title: 'Avg. User Sessions' },
    { name: 'avgClickCount', title: 'Avg. Click Count' },
];

export const COL_STYLES = [
    { columnName: 'website', width: '35%' },
    { columnName: 'trendingCategories', width: '25%' },
    { columnName: 'avgTimeOnPage', width: '13%', align: 'center' },
    { columnName: 'avgUserSessions', width: '14%', align: 'center' },
    { columnName: 'avgClickCount', width: '13%', align: 'center' },
];

export const DEVICE_OPTIONS = [
    { value: 'mobile', label: 'Mobile' },
    { value: 'desktop', label: 'Desktop' },
    { value: 'tablet', label: 'Tablet' },
];

export const COLORS = ['#5D5FEF', '#FF5C8E', '#369FFF', '#00D2FC', '#28C76F', '#FF9F43', '#EA5455', '#8b5cf6'];

export const DASHBOARD = {
    PAGE_SIZE: 5,
    NO_DATA: 'No website insights found',
}

export const GROWTH_ENGAGEMENT_CHART_CONFIG = {
    labelKey: 'web_url',
    valueKey: 'unique_visitors',
    title: 'Growth & Engagement',
    subtitle: 'Detailed traffic and user activity trends',
    xAxisLabel: 'Unique Visitors',
};

export const TOP_WEBSITES_CHART_CONFIG = {
    labelKey: 'web_url',
    valueKey: 'average_engagement_score',
    title: 'Top Websites',
    subtitle: 'Engagement score distribution among the most engaging websites',
    xAxisLabel: 'Engagement Score',
    xMax: 1,
};

// TODO: Remove mock data once API is available.
export const INSIGHTS_MOCK_DATA = {
    data: [
        { web_url: 'http://127.0.0.1:5500/test.html#', unique_visitors: 2 },
        { web_url: 'http://127.0.0.1:5500/test-crime-war.html', unique_visitors: 1 },
        { web_url: 'http://127.0.0.1:5500/test-crime-war.html#', unique_visitors: 1 },
        { web_url: 'http://127.0.0.1:5500/test.html', unique_visitors: 1 },
        { web_url: 'http://127.0.0.1:5500/test.html', unique_visitors: 3 },
    ]
};

// TODO: Remove mock data once API is available.
export const ENGAGEMENT_PEAK_TIME_MOCK_DATA = [
    { hour: '12 AM', avg_normalized_engagement_score: 0.12 },
    { hour: '2 AM',  avg_normalized_engagement_score: 0.08 },
    { hour: '4 AM',  avg_normalized_engagement_score: 0.05 },
    { hour: '6 AM',  avg_normalized_engagement_score: 0.18 },
    { hour: '8 AM',  avg_normalized_engagement_score: 0.45 },
    { hour: '10 AM', avg_normalized_engagement_score: 0.62 },
    { hour: '12 PM', avg_normalized_engagement_score: 0.78 },
    { hour: '2 PM',  avg_normalized_engagement_score: 0.85 },
    { hour: '4 PM',  avg_normalized_engagement_score: 0.80 },
    { hour: '6 PM',  avg_normalized_engagement_score: 0.72 },
    { hour: '8 PM',  avg_normalized_engagement_score: 0.65 },
    { hour: '10 PM', avg_normalized_engagement_score: 0.40 },
];

// TODO: Remove mock data once API is available.
export const DASHBOARD_TABLE_MOCK_DATA = {
    total: 4,
    data: [
        { web_url: 'http://127.0.0.1:5500/test.html', average_user_sessions: 378.56, average_click_count: 2.06, average_engagement_score: 0, average_time_on_page: 287.6, keywords: [['mobile', 'phones'], ['accessories', 'shop']] },
        { web_url: 'http://127.0.0.1:5500/test-crime-war.html', average_user_sessions: 15.4, average_click_count: 5.8, average_engagement_score: 0, average_time_on_page: 134.2, keywords: [['crime', 'news'], ['war', 'portal']] },
        { web_url: 'http://127.0.0.1:5500/test.html#', average_user_sessions: 422.1, average_click_count: 1.45, average_engagement_score: 0, average_time_on_page: 310.5, keywords: [['react', 'redux'], ['javascript', 'frontend']] },
        { web_url: 'http://127.0.0.1:5500/test-crime-war.html#', average_user_sessions: 67.95, average_click_count: 0.84, average_engagement_score: 0, average_time_on_page: 198.3, keywords: [['python', 'programming'], ['data', 'science']] },
    ]
};

// TODO: Remove mock data once API is available.
export const ENGAGEMENT_SCORE_MOCK_DATA = {
    data: [
        { web_url: 'https://example.com', average_engagement_score: 0.85 },
        { web_url: 'https://site-two.com', average_engagement_score: 0.72 },
        { web_url: 'https://site-three.com', average_engagement_score: 0.64 },
        { web_url: 'https://site-four.com', average_engagement_score: 0.51 },
        { web_url: 'https://site-five.com', average_engagement_score: 0.38 },
    ]
};

export const USER_PREFERENCES_MOCK_DATA = [
    { id: 1, name: 'Mobile Phone', count: 1, percentage: 16.666666666666664 },
    { id: 3, name: 'Speakers', count: 1, percentage: 16.666666666666664 },
    { id: 2, name: 'Organic Food', count: 1, percentage: 16.666666666666664 },
    { id: 4, name: 'Cheese', count: 1, percentage: 16.666666666666664 },
    { id: 6, name: 'Noodles', count: 1, percentage: 16.666666666666664 },
    { id: 5, name: 'Playstation', count: 1, percentage: 16.666666666666664 },
];
